// Shares the workspace's owner-counted pricing channel with durable panes.
// Cleanup removes only this response's demand, never the channel-wide flag.
export const subscribeWorkspaceResponseChart = ({
  threadUuid, idx, tickerId, scale, assetType,
  setChatFeatureDemand, onLiveChartChange, requestPricing,
}) => {
  if (!threadUuid || !idx || !tickerId) return () => {};
  const chart = { idx, tickerId: String(tickerId), scale, assetType };
  const demand = (on) => setChatFeatureDemand?.({
    threadUuid, feature: "pricing", ownerKey: idx, on, ttl: 30,
  });
  onLiveChartChange?.(chart);
  demand(true);
  requestPricing();
  const timer = setInterval(() => demand(true), 10_000);
  return () => {
    clearInterval(timer);
    demand(false);
    onLiveChartChange?.({ ...chart, active: false });
  };
};
